import {Box, Button, Typography} from '@mui/material';
import {SwapHoriz} from '@mui/icons-material';
import LobbyControls from './LobbyControls';
import PlayerList from './PlayerList';
import QuizInfo from './QuizInfo';
import ChatComponent from './ChatComponent';

export default function Lobby({
  lobbyId,
  selectedQuiz,
  isGameMaster,
  gameMasterParticipates,
  onToggleGameMasterParticipation,
  currentPlayerReady,
  allPlayersReady,
  players,
  onToggleReady,
  onQuizSelect,
  onStartGame,
  onLeaveLobby,
  messages,
  chatMessage,
  onMessageChange,
  onMessageSubmit,
  onEmojiClick,
  onGifClick,
  currentUser,
  anchorEl,
  giphyAnchorEl,
  onEmojiButtonClick,
  onGifButtonClick
}) {
  return (
    <Box className="lobby-wrapper">
      <Box className="lobby-main">
        {/* Linke Spalte */}
        <Box className="lobby-sidebar">
          <Box className="quiz-info-container glass">
            <Box className="quiz-info-header">
              <Typography variant="h6" component="h2" className="quiz-info-title">
                Nächstes Quiz
              </Typography>
              {isGameMaster && (
                <Button
                  onClick={onQuizSelect}
                  size="small"
                  className="quiz-select-button"
                  startIcon={<SwapHoriz />}
                  variant="outlined"
                >
                  Wechseln
                </Button>
              )}
            </Box>
            {selectedQuiz && <QuizInfo quiz={selectedQuiz} />}
          </Box>
          <PlayerList 
            className="glass"
            players={players}
            gameMasterId={Object.entries(players || {}).find(([, player]) => player.isGameMaster)?.[0]}
            gameMasterParticipates={gameMasterParticipates}
          />
        </Box>

        {/* Rechte Spalte */}
        <Box className="lobby-main-content">
          <Box className="lobby-mobile-controls">
            <LobbyControls
              className="glass"
              lobbyId={lobbyId}
              isGameMaster={isGameMaster}
              gameMasterParticipates={gameMasterParticipates}
              onToggleGameMasterParticipation={onToggleGameMasterParticipation}
              selectedQuiz={selectedQuiz}
              currentPlayerReady={currentPlayerReady}
              allPlayersReady={allPlayersReady}
              onToggleReady={onToggleReady}
              onStartGame={onStartGame}
              onLeaveLobby={onLeaveLobby}
              players={players}
              currentUser={currentUser}
            />
          </Box>
          <Box className="lobby-mobile-chat">
            <ChatComponent
              className="glass chat-container"
              messages={messages}
              chatMessage={chatMessage}
              onMessageChange={onMessageChange}
              onMessageSubmit={onMessageSubmit}
              onEmojiClick={onEmojiClick}
              onGifClick={onGifClick}
              currentUser={currentUser}
              gameMasterId={Object.entries(players || {}).find(([, player]) => player.isGameMaster)?.[0]}
              anchorEl={anchorEl}
              giphyAnchorEl={giphyAnchorEl}
              onEmojiButtonClick={onEmojiButtonClick}
              onGifButtonClick={onGifButtonClick}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
} 